/**
 * Menu Data Transformation Utilities
 * Handles transformation of API data to application format
 */

/**
 * Transform API menu item to application format
 * @param {Object} apiItem - Menu item from API
 * @returns {Object} - Transformed menu item
 */
export const transformMenuItem = (apiItem, parentCategory = null) => {
    return {
        id: apiItem.id,
        name: apiItem.name,
        description: apiItem.description,
        image: apiItem.image,
        price: parseFloat(apiItem.basePrice),
        categoryId: apiItem.categoryId ?? parentCategory?.id,
        categoryName:
            parentCategory?.name ||
            apiItem.Category?.name ||
            apiItem.categoryName ||
            null,
        subcategoryId: apiItem.subcategoryId,
        subcategoryName:
            apiItem.SubCategory?.name ||
            apiItem.subcategoryName ||
            null,
        hasVariations: apiItem.hasVariations,
        isVegetarian: apiItem.isVegetarian,
        isVegan: apiItem.isVegan,
        isSpicy: apiItem.isSpicy,
        preparationTime: apiItem.preparationTime,
        displayOrder: apiItem.displayOrder,
        frequentlyBoughtItemIds: apiItem.frequentlyBoughtItemIds || apiItem.frequentlyBoughtTogetherIds || apiItem.relatedMenuItemIds || [],
        frequentlyBoughtTogether: apiItem.frequentlyBoughtTogether || [],
        variations: apiItem.ItemVariations?.map((v) => ({
            id: v.id,
            name: v.name,
            price: parseFloat(v.price),
            displayOrder: v.displayOrder,
        })) || [],
        modifierOptions: apiItem.ModifierOptions?.map((m) => ({
            id: m.id,
            modifierId: m.modifierId,
            name: m.name,
            price: parseFloat(m.price),
            displayOrder: m.displayOrder,
            modifier: m.Modifier ? {
                id: m.Modifier.id,
                name: m.Modifier.name,
                description: m.Modifier.description,
                isRequired: m.Modifier.isRequired,
                minSelections: m.Modifier.minSelections,
                maxSelections: m.Modifier.maxSelections,
            } : null,
        })) || [],
    };
};

/**
 * Transform API response to flat menu items array
 * @param {Array} apiCategories - Categories array from API
 * @returns {Array} - Flat array of menu items
 */
export const transformMenuData = (apiCategories) => {
    if (!Array.isArray(apiCategories)) return [];

    const allItems = [];

    apiCategories.forEach((category) => {
        if (category.MenuItems && Array.isArray(category.MenuItems)) {
            category.MenuItems.forEach((item) => {
                allItems.push(transformMenuItem(item, category));
            });
        }
    });

    return allItems.sort((a, b) => a.displayOrder - b.displayOrder);
};

/**
 * Get offer items from menu data
 * @param {Array} apiCategories - Categories array from API
 * @returns {Array} - Array of items with offers
 */
export const extractOfferItems = (apiCategories) => {
    if (!Array.isArray(apiCategories)) return [];

    const offerItems = [];

    apiCategories.forEach((category) => {
        if (category.Offers && Array.isArray(category.Offers) && category.Offers.length > 0) {
            // Add items from categories that have offers
            if (category.MenuItems && Array.isArray(category.MenuItems)) {
                category.MenuItems.forEach((item) => {
                    offerItems.push(transformMenuItem(item));
                });
            }
        }
    });

    return offerItems;
};
